import { Skeleton } from '@/components/ui/skeleton';
import { ProductCard } from './ProductCard';
import { copy } from '@/content/copy';
import type { Product } from '@/features/products/types';

const LAYOUT =
  'grid grid-cols-[repeat(auto-fill,minmax(235px,1fr))] gap-x-[22px] gap-y-[38px] max-[860px]:grid-cols-2 max-[560px]:gap-x-3 max-[560px]:gap-y-[27px]';

export function ProductGrid({
  products,
  isPending,
  isError,
  emptyMessage = copy.catalog.empty,
}: {
  products: Product[] | undefined;
  isPending: boolean;
  isError: boolean;
  emptyMessage?: string;
}) {
  if (isPending) {
    return (
      <div className={LAYOUT}>
        {Array.from({ length: 4 }, (_, index) => (
          <div key={index}>
            <Skeleton className="aspect-[4/5] w-full" />
            <Skeleton className="mt-3.5 h-5 w-2/3" />
            <Skeleton className="mt-2 h-4 w-1/3" />
          </div>
        ))}
        <span className="sr-only">{copy.catalog.loading}</span>
      </div>
    );
  }

  if (isError) {
    return <p className="text-brand-muted">{copy.catalog.unavailable}</p>;
  }

  if (!products || products.length === 0) {
    return <p className="text-brand-muted">{emptyMessage}</p>;
  }

  return (
    <div className={LAYOUT}>
      {products.map((product) => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
  );
}
